import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import HomePage from "@/pages/HomePage";
import RegionPage from "@/pages/RegionPage";
import CountryPage from "@/pages/CountryPage";
import ExpoPage from "@/pages/ExpoPage";
import ProjectsPage from "@/pages/ProjectsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import FAQPage from "@/pages/aeo/FAQPage";
import GuidePage from "@/pages/aeo/GuidePage";
import ComparePage from "@/pages/aeo/ComparePage";
import LocationPage from "@/pages/aeo/LocationPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import BlogAdminPage from "@/pages/BlogAdminPage";
import CityPage from "@/pages/CityPage";
import BoothTypePage from "@/pages/BoothTypePage";
import UpcomingShowPage from "@/pages/UpcomingShowPage";
import StickyCTA from "@/components/StickyCTA";
import CaseStudyPage from "@/pages/CaseStudyPage";
import LegalPage from "@/pages/LegalPage";
import CostCalculatorPage from "@/pages/CostCalculatorPage";
import BadgePage from "@/pages/BadgePage";
import CookieBanner from "@/components/CookieBanner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // GA4 SPA page-view tracking
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/region/:slug" element={<RegionPage />} />
          <Route path="/country/:slug" element={<CountryPage />} />
          <Route path="/expo/:slug" element={<ExpoPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/guide/:slug" element={<GuidePage />} />
          <Route path="/compare/:slug" element={<ComparePage />} />
          <Route path="/location/:slug" element={<LocationPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/admin/blog" element={<BlogAdminPage />} />
          <Route path="/stand-builder" element={<CityPage />} />
          <Route path="/stand-builder/:slug" element={<CityPage />} />
          <Route path="/booth" element={<BoothTypePage />} />
          <Route path="/booth/:slug" element={<BoothTypePage />} />
          <Route path="/show" element={<UpcomingShowPage />} />
          <Route path="/show/:slug" element={<UpcomingShowPage />} />
          <Route path="/case-studies" element={<CaseStudyPage />} />
          <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
          <Route path="/tools/exhibition-stand-cost-calculator" element={<CostCalculatorPage />} />
          <Route path="/built-by-stagehook" element={<BadgePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <StickyCTA />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
